// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hide extra content when screen width is below 600px */`, "",{"version":3,"sources":["webpack://./src/styles/VersionManagement.scss"],"names":[],"mappings":"AAAA,wDAAA","sourcesContent":["/* Hide extra content when screen width is below 600px */\n@media (max-width: 1300px) {\n    .version-card .ant-card-extra {\n      // display: none;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
